<template>
    <section ref="section10" class="mx-auto flex h-full flex-col">
        <v-register-head @previous="9" :step="10"></v-register-head>
        <div
            class="flex h-full flex-col items-center justify-between px-4 py-8 md:px-12"
        >
            <form
                method="POST"
                :action="
                    registrationProcessData.routes.processFinishRegistration
                "
                id="process-finish-registration"
            >
                <input
                    type="hidden"
                    name="_token"
                    :value="registrationProcessData.csrfToken"
                />
                <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
                    <figure class="flex gap-3">
                        <div><v-icon icon="hand-wave" size="8"></v-icon></div>
                        <div class="flex flex-col justify-center">
                            <div class="mb-3 text-heading-3-desktop">
                                {{ user.full_name }}, dobrodošli na portalu N24!
                            </div>
                            <div class="text-body-regular text-black-40">
                                Odkrijte nepremičnine kot še nikoli doslej!
                            </div>
                        </div>
                    </figure>
                    <figure>
                        <img
                            class="lazy hidden lg:flex"
                            :src="'/assets/images/hiska-1-new.webp'"
                        />
                        <img
                            class="lazy -ml-4 -mr-4 min-w-[100vw] lg:hidden"
                            :src="'/assets/images/hiska-1-new.webp'"
                        />
                    </figure>
                </figure>
            </form>
        </div>
        <div
            class="flex h-full max-h-[102px] justify-between border-t px-4 pt-4"
        >
            <div class="flex w-full justify-center">
                <a
                    @click="submitForm('process-finish-registration')"
                    class="button button--form"
                >
                    <label class="text-small-text-medium">Končajte</label>
                    <v-icon icon="circle-check" size="4"></v-icon>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        registrationProcessData: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        user: {
            type: Object,
            required: true,
        },
        session: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
    },
};
</script>
